export const NOT_USE_PARAMTER = 0;
export const FUNC_ID_ALL = -1;

export const HTTP_STATUS_VALIDATION = 400;
export const TIME_SEVEN_AGO = 1;
export const TIME_MONTH_TYPE = 2;
export const TIME_YEAR_TYPE = 3;
export const TIME_BETWEEN_TYPE = 4;
export const LAST_WEEK = 5;
export const CURRENT_WEEK = 6;
export const LAST_MONTH = 7;
export const CURRENT_MONTH = 8;
export const LAST_YEAR = 9;
export const CURRENT_YEAR = 10;

export const STRING_EMPTY = '';
